angular.module('app.services').service('permissionsService', function ($translate, api) {
    const Service = this;

    Service._model = api('permissions');

    Service.getAll = () =>
        Service._model.list().then((response) => {
            // budujemy
            let permissions = _.map(response.data, (permission) => {
                const pair = permission.name.split('__');

                permission.translation = `${$translate.instant(pair[0])}: ${$translate.instant(`permissions.${pair[1]}`)}`;

                return permission;
            });

            // sortujemy
            permissions = permissions.sort((a, b) => (a.translation < b.translation ? -1 : a.translation > b.translation ? 1 : 0));

            // grupujemy
            let lastGroupName = null;
            return _.map(permissions, (permission) => {
                const groupName = permission.translation.substr(0, permission.translation.indexOf(':'));

                if (null === lastGroupName || lastGroupName !== groupName) {
                    lastGroupName = groupName;
                    permission.groupName = lastGroupName;
                } else {
                    permission.groupName = '';
                }

                return permission;
            });
        });
});
